export const GENERAL_ERROR =
  "We're sorry, but we could not complete your request. Please try again later.";

export const generatingMessage = (what) =>
  `The requested ${what}(s) are being generated and will be emailed to you shortly.`;

export const IDLE = "idle";
export const ERROR = "error";
export const LOADING = "loading";
export const SAVING = "saving";
export const DELETING = "deleting";

export const NO_TARIFF_APPLIED = "No Tariff Applied";
export const WARNING_COLOR = "#F3C820";

export const EQUIPMENT_TEMPLATE_WAQ = 2;
export const EQUIPMENT_TEMPLATE_WBR = 1;

export const validRFChannels = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
];
export const validTimeslots = [...Array(256).keys()];

export const FUNCTIONALLY_ACTIVE_STATUSES = [1, 4, 5];

export const CALIBRATION_GROUP_LOCKED = 1; // special value in wellstat_calibration_groups. When LOCKED, a device does not get included in automated or bulk operations

